import React from "react";

import dndImage from '../img/jsDnD.png';
import SR2Image from '../img/StarRack2.png';
import GFImage from '../img/GoodFoodLogo.png';
import MDImage from '../img/MERN.png';
import WSDImage from '../img/WebShop.png';
import RCDImage from '../img/Chat.png';
import JTImage from '../img/Java.png';
import BugImage from '../img/BugTracker.png';
import USPImage from '../img/USParks.png';
import MUIImage from '../img/MatUI.png';
import MSImage from '../img/MineSweep.png';
import TTTImage from '../img/TicTacToe.png';
import PPImage from '../img/Pizza.png';
import ExchImage from '../img/Exchange.png';
import MRobImage from '../img/MrRog.png';

const ProjectData = [
  {
    "Title": "jsDND",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": dndImage, 
    "GitHub": "https://github.com/mmanchee/jsDnD",
    "GhPages": "https://mmanchee.github.io/jsDnD/",
    "Tutorial": "false",
    "Description": "This is a Game based on DnD 5th Edition. Built with JavaScript and Bootstrap as the main components. This project was built during the first team week at Epicodus.",    
  },
  {
    "Title": "Star Racks 2",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": SR2Image,
    "GitHub": "https://github.com/mmanchee/StarRacks2.1",
    "GhPages": "https://mmanchee.github.io/StarRacks2/",
    "Tutorial": "false",
    "Description": "This is a tongue in cheek, Inventory Management program. Built with React/Redux and Bootstrap as the main components. This project was built for a Friday Solo project at Epicodus.",
  },
  {
    "Title": "Good Food",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": GFImage, 
    "GitHub": "https://github.com/mmanchee/good-food",
    "GhPages": "http://mmanchee.github.io/good-food-demo",
    "Tutorial": "false",
    "Description": "This is a project that uses food and allergies to determine the best foods for you. This is only a demo. Built with React, Hooks, and Bootstrap. This project was built as a capstone project for Epicodus.",
  },
  {
    "Title": "MERN Demo",
    "Complete": "false",
    "Type": "Tutorial",
    "Image": MDImage,
    "GitHub": "https://github.com/mmanchee/MERN_Example",
    "GhPages": "false",
    "Tutorial": "https://www.youtube.com/watch?v=ngc9gnGgUdA&t",
    "Description": "This is a sample project for knowledge as I entered my internship with JobsMight. Built with a MERN stack (MongoDB, Expressjs, React, and Nodejs), Material-ui, Stripejs, Swagger, and APIs. This project is a tutorial from JavaScript Mastery on YouTube",
  },
  {
    "Title": "Web Shop Demo",
    "Complete": "false",
    "Type": "Tutorial",
    "Image": WSDImage,
    "GitHub": "false",
    "GhPages": "false",
    "Tutorial": "https://www.youtube.com/watch?v=377AQ0y6LPA&t",
    "Description": "This is a Web Shop Tutorial. Built with React, Commercejs, Stripejs. This project is a tutorial from JavaScript Mastery on YouTube",
  },  
  {
    "Title": "React Chat Demo",
    "Complete": "false",
    "Type": "Tutorial",
    "Image": RCDImage,
    "GitHub": "false",
    "GhPages": "false",
    "Tutorial": "https://www.youtube.com/watch?v=jcOKU9f86XE",
    "Description": "This is a Chat App Tutorial. Built with React. This project is a tutorial from JavaScript Mastery on YouTube",
  },  
  {
    "Title": "Java Tutorial",
    "Complete": "false",
    "Type": "Tutorial",
    "Image": JTImage,
    "GitHub": "false",
    "GhPages": "false",
    "Tutorial": "https://www.youtube.com/watch?v=eIrMbAQSU34&t",
    "Description": "This is a Java Tutorial. This project is a tutorial from Programming with Mosh on YouTube",
  },  
  {
    "Title": "BugLister",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": BugImage, 
    "GitHub": "https://github.com/mmanchee/BugLister",
    "GhPages": "false",
    "Tutorial": "false",
    "Description": "This is a Bug Tracker. Built with C# and Razor as the main components. This was built during a multi-day project at Epicodus.",    
  },
  {
    "Title": "US Parks",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": USPImage, 
    "GitHub": "https://github.com/mmanchee/USParks-Client",
    "GhPages": "false",
    "Tutorial": "false",
    "Description": "This is a client interface for a API created earlier at Epicodus. Built with React/Redux and Bootstrap as the main components. This project was built at Epicodus.",
  },
  {
    "Title": "MaterialUIExample",
    "Complete": "true",
    "Type": "Tutorial",
    "Image": MUIImage, 
    "GitHub": "https://github.com/mmanchee/MaterialUIExample",
    "GhPages": "http://mmanchee.github.io/MaterialUIExample",
    "Tutorial": "https://www.youtube.com/watch?v=vyJU9efvUtQ",
    "Description": "This is a project to play around with Material-ui. Built with Material-ui. This project was tutorial from Traversy Media on YouTube.",
  },
  {
    "Title": "Mine Sweeper",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": MSImage,
    "GitHub": "https://github.com/mmanchee/minesweeper-redux",
    "GhPages": "http://mmanchee.github.io/minesweeper-redux",
    "Tutorial": "false",
    "Description": "This is a Mine Sweeper game. Built with React/Redux. This project was built at Epicodus.",
  },
  {
    "Title": "Tic Tac Toe",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": TTTImage, 
    "GitHub": "https://github.com/mmanchee/tic-tac-toe-redux",
    "GhPages": "http://mmanchee.github.io/tic-tac-toe-redux",
    "Tutorial": "false",
    "Description": "This is a Tic Tac Toe Game. Built with React/Redux. This project was built at Epicodus.",    
  },
  {
    "Title": "Pizza Palor",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": PPImage,
    "GitHub": "https://github.com/mmanchee/PizzaParlor",
    "GhPages": "https://mmanchee.github.io/PizzaParlor/",
    "Tutorial": "false",
    "Description": "This is a Pizza Parlor to order pizza. Built with JavaScript and Bootstrap as the main components. This project was built for a Friday Solo project at Epicodus.",
  },
  {
    "Title": "Exchange",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": ExchImage, 
    "GitHub": "https://mmanchee.github.io/Exchange/",
    "GhPages": "http://mmanchee.github.io/Exchange/",
    "Tutorial": "false",
    "Description": "This is a currency exchange site. Built with JavaScript and Bootstrap as the main components. This project was built for a Friday Solo project at Epicodus.",
  },
  {
    "Title": "mr Roboger",
    "Complete": "true",
    "Type": "Epicodus",
    "Image": MRobImage,
    "GitHub": "https://github.com/mmanchee/mrRoboger",
    "GhPages": "http://mmanchee.github.io/mrRoboger",
    "Tutorial": "",
    "Description": "This is a Robot substitution project. Built with JavaScript and Bootstrap as the main components. This project was built for a Friday Solo project at Epicodus.",
  },
];

export default ProjectData